import BookIndex from "components/shared/book/list";
import ScrollPositionContext from "contexts/scrollPosition";
import { paths } from "helpers/paths";
import { tableContainer } from "helpers/redux";
import React from "react";
import { Link } from "react-router-dom";

class RouteTemplates extends BookIndex {
    static contextType = ScrollPositionContext;

    renderTableRow = (item, index) => {
        const { id, name } = item;
        return (
            <tr
                key={id}
                className={this.context.prevItemId === id ? "book-tr__prev-row" : ""}
                onClick={() => this.props.history.push(paths.routeTemplatesShow(id))}
            >
                <td>{index + 1}</td>
                <td>{id}</td>
                <td>
                    <Link to={paths.routeTemplatesShow(id)}>{name}</Link>
                </td>
            </tr>
        );
    };

    thead = () => {
        return (
            <thead className="thead-light">
                <tr>
                    <th>#</th>
                    <th>ID</th>
                    <th>Название</th>
                </tr>
            </thead>
        );
    };
}

export default tableContainer(RouteTemplates, "routetemplates");
